var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.598,
    height: 24.598,
    viewBox: "0 0 24.598 24.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "time-quarter-to-svgrepo-com",
    d: "M24.6,12.3A12.3,12.3,0,0,1,0,12.3a1.025,1.025,0,1,1,2.05,0A10.249,10.249,0,1,0,12.3,2.05,1.025,1.025,0,1,1,12.3,0,12.312,12.312,0,0,1,24.6,12.3ZM10.533,11.274H8.2a1.025,1.025,0,0,0,0,2.05h2.334a2.044,2.044,0,1,0,2.791-2.791V7.174a1.025,1.025,0,1,0-2.05,0v3.359a2.05,2.05,0,0,0-.741.741ZM1.872,9A1.025,1.025,0,1,0,.848,7.978,1.025,1.025,0,0,0,1.872,9ZM4.326,5.337A1.025,1.025,0,1,0,3.3,4.312,1.025,1.025,0,0,0,4.326,5.337ZM7.973,2.912A1.025,1.025,0,1,0,6.948,1.887,1.025,1.025,0,0,0,7.973,2.912Z",
    fill: "#d5ad67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeEvent);
export default __webpack_public_path__ + "static/media/time-event.234403e90d264cd7d94c6fb25a1224bd.svg";
export { ForwardRef as ReactComponent };